import { apiConfig } from '../api-config';

export interface SetReadNotificationParams {
  notificationId: number;
  userId: number;
  tokenKey: string;
}

export const setReadNotification = (params: SetReadNotificationParams) => apiConfig.post('api/Notification/set-read', params);
